import React, { Component } from 'react';
import NavBar from '../layout/NavBar';
import csvParse from 'csv-parse/lib/sync';
import ResultModal from '../common/modal/ResultModal';
import {
  OuterComponent,
} from './StyledComponent';
import { Button } from 'reactstrap';
import OnlineConsultConfirmModal from './OnlineConsultConfirmModal';
import LoadingComponentAbsolute from '../common/LoadingComponentAbsolute';
import { onlineConsultationBooking } from '../../services/api/online-consultation-booking';
import Select from 'react-select';
import { Async } from 'react-select';
import { fetchAllSponsors, searchDopeEntities } from '../../services/api/sponsors';
import debounce from 'lodash.debounce';
import ConsultOnlineModal from '../common/modal/consultOnlineModal';
import DependentModal from '../common/modal/dependentModal';
// import OpdHolderTable from './OpdHolderTable';
// import UpdateOpdMembersTable from './UpdateOpdMembersTable';

class OnlineConsultationBooking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      showModal: false,
      showOnlineConfirmModal: false,
      summary: [],
      premium: '',
      modalHeader: '',
      modalBody: '',
      bgColor: '',
      data: [],
      tableData: [],
      submitId: '',
      sponsorId: null,
      showUpdateTable: false,
      selectedOption: null,
      showOpdTable: true,
      invalidRecord: [],
      columnsNames: [],
      sponsors: [],
      records: [],
      search: '',
      pageSize: 10,
      pages: 0,
      filtered: [],
      bookConsultModal:false,
      addDependentModal:false,
      consultationPayType: 'wallet',
      selectedEntityOption: null,
    };
    this.debouncedEntityLoad = debounce(this._searchDopeEntities, 500);
  }
  componentDidMount = () => {
    this.getSponsors();
  };
  getSponsors = () => {
    return fetchAllSponsors()
      .then((response) => {
        console.log(response, 'Response from server');
        const sponsors = response.data.map((sponsor) => {
          return {
            value: sponsor.sponsorId,
            label: sponsor.sponsorName,
          };
        });
        this.setState({
          sponsors,
        });
      })
      .catch(() => {
        this.setState({
          sponsors: [],
        });
      });
  };
  // Upload the raw bulk-booking file to the backend, which parses (CSV/Excel),
  // validates columns and runs the booking flow.
  uploadBookingFile = (file) => {
    const isFree = this.state.consultationPayType === 'wallet' ? false : true;
    // Wallet: entity is mandatory; entityId + sponsorId both come from the
    // selected entity. Free: only the sponsor dropdown is used.
    const entityId = !isFree && this.state.selectedEntityOption ? this.state.selectedEntityOption.value : null;
    const sponsorId = !isFree
      ? (this.state.selectedEntityOption ? this.state.selectedEntityOption.sponsorId : null)
      : this.state.sponsorId;

    if (!isFree && !entityId) {
      this.setState({
        showModal: true,
        modalHeader: 'Warning',
        modalBody: 'Please select an entity for the wallet booking.',
        bgColor: 'bg-warning',
      });
      return;
    }
    if (isFree && !sponsorId) {
      this.setState({
        showModal: true,
        modalHeader: 'Warning',
        modalBody: 'Please select sponsor first.',
        bgColor: 'bg-warning',
      });
      return;
    }
    this.setState({ loading: true });
    onlineConsultationBooking(file, sponsorId, isFree, entityId)
      .then((resp) => {
        // Backend processes asynchronously and emails a success/failure report.
        // A 200 with a non-success message is still a failure.
        if (resp && resp.message !== 'success') {
          this.setState({
            loading: false,
            showModal: true,
            modalHeader: 'Booking Failed',
            modalBody: `Error : "${(resp && resp.errorMessage) || 'Something went wrong'}". Check the file and try again.`,
            bgColor: 'bg-danger',
          });
          return;
        }
        this.setState({
          loading: false,
          showModal: true,
          modalHeader: 'Booking Initiated',
          modalBody:
            (resp && resp.data) ||
            'Bulk booking has been initiated. You will receive an email with the results.',
          bgColor: 'bg-success',
        });
      })
      .catch((err) => {
        let errorMessage = err.message;
        if (err.response !== undefined && err.response.data) {
          errorMessage = err.response.data.errorMessage || err.response.data.errorDebug || errorMessage;
        }
        this.setState({
          loading: false,
          showModal: true,
          modalHeader: 'Booking Failed',
          modalBody: `Error : "${errorMessage}". Check the file and try again.`,
          bgColor: 'bg-danger',
        });
      });
  };
  handleOnboard = () => {
    document.querySelector('#csvOnboardingAttachment').click();
  };
  handleOnboardAttachment = () => {
    const file = document.querySelector('#csvOnboardingAttachment').files[0];
    if (file) {
      this.uploadBookingFile(file);
    }
    document.querySelector('#csvOnboardingAttachment').value = null;
  };
  // Update Member Details
  handleUpdate = () => {
    document.querySelector('#csvUpdateAttachment').click();
  };
  handleUpdateAttachment = () => {
    const file = document.querySelector('#csvUpdateAttachment').files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const res = reader.result;
      // console.log({ res });

      try {
        const data = csvParse(res, {
          // columns: true,
          skip_empty_lines: true,
          quote: '"',
          ltrim: true,
          rtrim: true,
          delimiter: ',',
        });
        const tableData = csvParse(res, {
          columns: true,
          skip_empty_lines: true,
          quote: '"',
          ltrim: true,
          rtrim: true,
          delimiter: ',',
        });
        // console.log({ data, tableData });
        this.setState({ data: data });
        // console.log(this.state.data, 'dataaas');
        this.checkUpdateData(data, tableData);
      } catch (err) {
        // console.log(err.message, 'err in parse');
        this.setState({
          showModal: true,
          modalHeader: 'Failed',
          modalBody: err.message,
          bgColor: 'bg-danger',
        });
      }
    };
    reader.readAsText(file);
    document.querySelector('#csvUpdateAttachment').value = null;
  };
  // Sponsor dropdown (free flow only) — the wallet flow derives the sponsor
  // from the selected entity instead.
  handleChange = (event) => {
    this.setState({
      sponsorId: event.value,
      selectedOption: event,
    });
  };

  // Searchable entity dropdown (wallet flow). loadOptions for the Async select.
  // Each option carries its sponsorId so entity + sponsor stay together.
  _searchDopeEntities = (val, callback) => {
    searchDopeEntities(val)
      .then((response) => {
        const result = (response && response.data) || [];
        const options = result.map((ele) => ({
          label: ele.entityName,
          value: ele.entityId,
          sponsorId: ele.sponsorId,
        }));
        if (callback) callback(options);
      })
      .catch(() => {
        if (callback) callback([]);
      });
  };

  handleEntityChange = (event) => {
    this.setState({ selectedEntityOption: event || null });
  };

  openBookConsultModal = () => {
    console.log('check  ')
    this.setState({
      bookConsultModal:true
    })
  }

  addDependentModal = () =>{
    this.setState({
      addDependentModal:true
    })
  }
  handleConsultationPayType = (type) => {
    this.setState({
      consultationPayType: type
    });
  };

  render() {
    return (
      <OuterComponent>
        <NavBar />

        {/* Page Header */}
        <div
          style={{
            marginTop: '4rem',
            padding: '20px 24px 16px',
            backgroundColor: '#fff',
            borderBottom: '2px solid #e5e7eb',
          }}
        >
          <h4 style={{ margin: 0, fontWeight: 600, color: '#1f2937' }}>
            Online Consultation Booking
          </h4>
          <p style={{ margin: '6px 0 0', fontSize: '13px', color: '#6b7280' }}>
            For partners like Axis Bank. Upload a CSV or Excel (.xlsx/.xls) file with columns: Name, DoctorId, MobileNo, Dob, Email, Platform, Gender, Relation, MemberId (optional), PolicyNumber (optional).
          </p>
        </div>

        {/* Controls Panel */}
        <div
          style={{
            padding: '16px 24px',
            backgroundColor: '#f9fafb',
            borderBottom: '1px solid #e5e7eb',
          }}
        >
          {/* Row 1: Sponsor + Pay Type */}
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '24px', flexWrap: 'wrap' }}>
            {/* Sponsor Select (free flow only) */}
            {this.state.consultationPayType === 'free' && (
              <div style={{ minWidth: 240, width: 280 }}>
                <label style={{ fontSize: '11px', fontWeight: 600, color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '5px', display: 'block' }}>
                  Sponsor
                </label>
                <Select
                  onChange={this.handleChange}
                  options={this.state.sponsors}
                  placeholder="Select sponsor..."
                  value={this.state.selectedOption}
                  styles={{
                    control: (base) => ({ ...base, fontSize: '13px', minHeight: '36px' }),
                    option: (base) => ({ ...base, fontSize: '13px' }),
                  }}
                />
              </div>
            )}

            {/* Entity search (wallet only) — sponsor derived from selected entity */}
            {this.state.consultationPayType === 'wallet' && (
              <div style={{ minWidth: 240, width: 280 }}>
                <label style={{ fontSize: '11px', fontWeight: 600, color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '5px', display: 'block' }}>
                  Entity
                </label>
                <Async
                  cacheOptions={false}
                  defaultOptions
                  onChange={this.handleEntityChange}
                  loadOptions={(val, callback) => this.debouncedEntityLoad(val, callback)}
                  placeholder="Search entity..."
                  value={this.state.selectedEntityOption}
                  styles={{
                    control: (base) => ({ ...base, fontSize: '13px', minHeight: '36px' }),
                    option: (base) => ({ ...base, fontSize: '13px' }),
                  }}
                />
              </div>
            )}

            {/* Pay Type */}
            <div>
              <label style={{ fontSize: '11px', fontWeight: 600, color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px', display: 'block' }}>
                Payment Type
              </label>
              <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#374151', cursor: 'pointer', margin: 0 }}>
                  <input
                    type="radio"
                    name="consultationPayType"
                    checked={this.state.consultationPayType === 'wallet'}
                    onChange={() => this.handleConsultationPayType('wallet')}
                  />
                  Wallet
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#374151', cursor: 'pointer', margin: 0 }}>
                  <input
                    type="radio"
                    name="consultationPayType"
                    checked={this.state.consultationPayType === 'free'}
                    onChange={() => this.handleConsultationPayType('free')}
                  />
                  Free
                </label>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div style={{ borderTop: '1px solid #e9ecef', margin: '14px 0' }} />

          {/* Row 2: Action Buttons */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <input
              type="file"
              id="csvOnboardingAttachment"
              accept=".csv,.xlsx,.xls"
              style={{ display: 'none' }}
              onChange={this.handleOnboardAttachment}
            />
            <Button
              color="primary"
              size="sm"
              style={{ borderRadius: '5px', padding: '7px 18px', fontSize: '13px' }}
              onClick={this.handleOnboard}
            >
              Bulk Booking
            </Button>
            <Button
              color="info"
              size="sm"
              style={{ borderRadius: '5px', padding: '7px 18px', fontSize: '13px' }}
              onClick={() => this.openBookConsultModal()}
            >
              Book Online Consult
            </Button>
            <Button
              color="secondary"
              size="sm"
              style={{ borderRadius: '5px', padding: '7px 18px', fontSize: '13px' }}
              onClick={() => this.addDependentModal()}
            >
              Add Dependent
            </Button>
          </div>
        </div>

        {/* Modals */}
        {this.state.showOnlineConfirmModal && (
          <OnlineConsultConfirmModal
            modalHeader={this.state.modalHeader}
            closeModal={() =>
              this.setState({ showOnlineConfirmModal: false, loading: false })
            }
            invalidRecord={this.state.invalidRecord}
          />
        )}
        {this.state.showModal && (
          <ResultModal
            modalHeader={this.state.modalHeader}
            modalBody={this.state.modalBody}
            closeModal={() => this.setState({ showModal: false })}
            bgColor={this.state.bgColor}
          />
        )}
        {this.state.bookConsultModal && (
          <ConsultOnlineModal
            openModal={this.openBookConsultModal}
            modalIsOpen={this.state.bookConsultModal}
            closeModal={() => this.setState({ bookConsultModal: false })}
          />
        )}
        {this.state.addDependentModal && (
          <DependentModal
            openModal={this.addDependentModal}
            modalIsOpen={this.state.addDependentModal}
            closeModal={() => this.setState({ addDependentModal: false })}
          />
        )}
        {this.state.loading ? <LoadingComponentAbsolute /> : null}
      </OuterComponent>
    );
  }
}

export default OnlineConsultationBooking;
